import React from 'react';

import {PrimaryButton} from '~/components/controls';
import PropTypes from 'prop-types';

const Changes = ({selected, hasChanges, onAdd}) => {
  const count =
    selected.components.length +
    Object.keys(selected.codes).length +
    Object.keys(selected.works).length +
    Object.keys(selected.extras).length;

  return (
    <PrimaryButton disabled={!hasChanges()} onPress={onAdd}>
      Toevoegen{count > 0 ? <>&nbsp;({count})</> : <></>}
    </PrimaryButton>
  );
};
Changes.propTypes = {
  selected: PropTypes.any,
  hasChanges: PropTypes.any,
  onAdd: PropTypes.any,
};


export default Changes;
